import { Keyboard } from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Badge } from '@/components/ui/badge'
import { formatShortcut } from '@/hooks/useKeyboardShortcuts'

interface KeyboardShortcut {
  key: string
  ctrlKey?: boolean
  metaKey?: boolean
  shiftKey?: boolean
  description: string
  action: () => void
}

interface KeyboardShortcutsModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  shortcuts: KeyboardShortcut[]
}

export function KeyboardShortcutsModal({
  open,
  onOpenChange,
  shortcuts,
}: KeyboardShortcutsModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <Keyboard className="h-5 w-5 text-primary" />
            <DialogTitle>Keyboard Shortcuts</DialogTitle>
          </div>
          <DialogDescription>
            Use these keyboard shortcuts to navigate quickly through the application
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-2 py-4">
          {shortcuts.map((shortcut, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-3 rounded-lg hover:bg-muted transition-colors"
            >
              <span className="text-sm">{shortcut.description}</span>
              <Badge variant="outline" className="font-mono">
                {formatShortcut(shortcut)}
              </Badge>
            </div>
          ))}
        </div>

        <div className="flex items-center gap-2 text-xs text-muted-foreground pt-4 border-t">
          <Keyboard className="h-3 w-3" />
          <span>Shortcuts work when not typing in an input field</span>
        </div>
      </DialogContent>
    </Dialog>
  )
}
